// extracted by mini-css-extract-plugin
module.exports = {"title":"MarketValue__title___1c4Ct"};